import { JSX } from "react";
export { ActionForm, QueryForm, ActionSubmit } from "./form";
export { ActionTrigger } from "./trigger";
export { TransitionProvider } from "./context";

export type ActionReturnType =
  | JSX.Element
  | void
  | undefined
  | { redirect: string }
  | { back: true }
  | { actionResult: { message: string; status: "success" | "error" | "default" | "loading" } };
export type Action<I> = (input: I) => Promise<ActionReturnType>;

export {
  Feedback,
  FeedbackDialog,
  FeedbackSwap,
  FeedbackSlot,
  FeedbackPopover,
  FeedbackToast,
} from "./feedback";
export { ErrorMessage } from "./message";
